import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import FormRenderer, {
  ComponentMapper,
  FormTemplate,
  componentTypes,
} from "../../../common/FormRenderer";
import { Button } from "react-bootstrap";
import { getValue } from "../../../../utils/common";
import { GetActionTitle } from "../Master.constants";

function VendorCategoryDetails({ action, record : data, onClose }: any) {
  const [vc, setVc] = useState<any>({ hideButtons: true });

  const schema = {
    fields: [
      {
        component: componentTypes.PLAIN_TEXT,
        name: "name",
        label: "Vendor Category",
        content: getValue(vc, "name"),
      },
    ],
  };

  useEffect(() => {
    if (data) {
      setVc({ ...vc, ...data });
    }
  }, [data]);

  return (
    <>
      <Modal
        show={true}
        backdrop="static"
        dialogClassName="drawer"
        animation={false}
      >
        <Modal.Header closeButton={true} onHide={onClose}>
          <Modal.Title className="bg">
            {GetActionTitle("Vendor Category", action)}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormRenderer
            FormTemplate={FormTemplate}
            initialValues={vc}
            componentMapper={ComponentMapper}
            schema={schema}
          />
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between">
          <Button
            variant="primary"
            onClick={onClose}
            className="px-4 ms-auto"
          >
            {"Close"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default VendorCategoryDetails;
